<template>
  <div class="fixed inset-0 bg-black/50 z-50 flex justify-end">
    <div class="bg-white dark:bg-gray-800 w-full max-w-lg overflow-y-auto p-6">
      <div class="flex justify-between items-center mb-6">
        <h3 class="text-lg font-semibold dark:text-white">
          Edit Post
        </h3>
        <button @click="$emit('close')" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 text-xl">
          &times;
        </button>
      </div>

      <div v-if="post.image_url" class="mb-4">
        <img :src="post.image_url" class="w-full rounded-lg">
      </div>

      <UiControl id="post-image" label="Replace Image">
        <input type="file" accept="image/*" @change="onImageSelect" class="text-sm dark:text-gray-300">
      </UiControl>

      <UiControl id="post-title" label="Title">
        <UiInput v-model="form.title" size="sm" />
      </UiControl>

      <UiControl id="post-body" label="Body" :hint="`${form.body?.length || 0} / 1500 characters`">
        <UiTextarea v-model="form.body" size="sm" />
      </UiControl>

      <div class="grid grid-cols-2 gap-4">
        <UiControl id="edit-post-type" label="Post Type">
          <UiSelect
            id="edit-post-type"
            v-model="form.post_type"
            :options="[{ id: 'update', title: 'Update' }, { id: 'event', title: 'Event' }]"
            size="sm" />
        </UiControl>

        <UiControl id="edit-cta-type" label="CTA">
          <UiSelect
            id="edit-cta-type"
            v-model="form.cta_type"
            :options="[{ id: 'call_now', title: 'Call Now' }, { id: 'learn_more', title: 'Learn More' }]"
            size="sm" />
        </UiControl>

        <UiControl id="edit-scheduled-date" label="Scheduled Date">
          <UiInput v-model="form.scheduled_date" type="date" size="sm" />
        </UiControl>

        <UiControl v-if="form.post_type === 'event'" id="edit-event-end" label="Event End Date">
          <UiInput v-model="form.event_end_date" type="date" size="sm" />
        </UiControl>
      </div>

      <UiControl id="edit-utm-url" label="UTM URL">
        <UiInput v-model="form.utm_url" size="sm" />
      </UiControl>

      <div class="flex justify-end gap-3 pt-4 border-t dark:border-gray-700">
        <button @click="$emit('close')" class="btn btn-secondary btn-sm">
          Cancel
        </button>
        <button @click="save" :disabled="saving" class="btn btn-primary btn-sm">
          {{ saving ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { updateGbpPost, uploadGbpPostImage } from '~/javascript/api/gbp_posts'
import UiInput from '~/javascript/components/ui/form/input/input.vue'
import UiTextarea from '~/javascript/components/ui/form/textarea/textarea.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'

const props = defineProps({ post: { type: Object, default: () => null } })
const emit = defineEmits(['saved', 'close'])

const form = reactive({ ...props.post })
const saving = ref(false)
const imageFile = ref(null)

function onImageSelect(e) {
  imageFile.value = e.target.files[0]
}

async function save() {
  saving.value = true
  try {
    if (imageFile.value) await uploadGbpPostImage(props.post.id, imageFile.value)
    await updateGbpPost(props.post.id, { gbp_post: form })
    emit('saved')
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert(e.response?.data?.error || 'Failed to save')
  } finally {
    saving.value = false
  }
}
</script>
